import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { includes, prop, propOr } from 'ramda';
import withUser from './withUser';

// `render` must be destructured out of `rest`: React Router v5 gives `component`
// precedence over `render`, so any route prop leaking through would silently
// bypass the roles check below.
const ProtectedRoute = ({ roles = [], userTeam, userIsSuperAdmin, Component, render, ...rest }) => {
  const currentRoles = propOr([], 'roles', userTeam);
  const isAllowed = userIsSuperAdmin || currentRoles.some(role => includes(prop('role', role), roles));

  const renderFn = (routeProps) => {
    if (!isAllowed) return <Redirect to="/" />;
    return render ? render(routeProps) : <Component />;
  };

  return <Route {...rest} render={renderFn} />;
};

export default withUser(ProtectedRoute);
